{
    const brandId = 'CAPITALIX';
    const DESKTOP_SCREEN = 1192;
    const topMoversPane = document.getElementById('assetsPane2');
    const topMoversAPI = `${m.host.api}/history/top-movers?count=7&brand_id=${brandId}`;
    const widgetsUpdatedEvent = new CustomEvent('ngpWidgetsUpdated');

    const initTopMoversSlider = () => {
        fetch(topMoversAPI)
            .then(res => res.json())
            .then(data => createTopMoversList(data.symbols, topMoversPane))
            .then(() => document.dispatchEvent(widgetsUpdatedEvent))
            .catch(err => console.warn(err));
    };

    const createTopMoversList = (list, container) => {
        const ul = document.createElement('ul');
        ul.className = 'assets__list js-assets-list';

        list.forEach(item => {
            const li = document.createElement('li');
            li.className = 'assets__item';

            const widget = document.createElement('ngp-asset-widget');
            widget.className = 'assets__card';
            widget.setAttribute('symbol-id', item.id);
            widget.setAttribute('symbol', parseSymbol(item.id));

            li.append(widget);
            ul.append(li);
        });

        // add stub to the end of the list
        const stub = `
        <li class="assets__item">
            <div class="asset-stub">
                <div class="asset-stub__header">
                    <div class="asset-stub__logo"></div>
                    <div class="asset-stub__name"></div>
                    <div class="asset-stub__description"></div>
                </div>
                <div class="asset-stub__content">
                    <div class="asset-stub__indicator"></div>
                    <div class="asset-stub__label"></div>
                    <img class="asset-stub__chart" src="/wp-content/themes/capitalixau/assets/img/no-chart.svg" alt="chart">
                </div>
                <div class="asset-stub__footer">
                    <ngp-auth-login class="asset-stub__link no-register_flex" text="${m.trans.get('Explore more')}">
                        ${m.trans.get('Explore more')}
                    </ngp-auth-login>
                    <a class="asset-stub__link register_flex" href="/trade/assets/all">${m.trans.get('Explore more')}</a>
                </div>
            </div>
        </li>`;
        ul.insertAdjacentHTML('beforeend', stub);

        // add filled list to the container
        container.innerHTML = '';
        container.append(ul);

        // default slick init
        initSlick(ul);
        // responsive slick init
        $(window).on('load resize orientationchange', () => { initSlick(ul) });
    };

    const initSlick = (elem) => {
        if ($(window).width() >= DESKTOP_SCREEN) {
            if ($(elem).hasClass('slick-initialized')) {
                $(elem).slick('unslick');
            }
            return false;
        }

        if (!$(elem).hasClass('slick-initialized')) {
            return $(elem).slick({
                dots: false,
                arrows: false,
                infinite: false,
                initialSlide: 1,
                slidesToShow: 1,
                centerMode: true,
                variableWidth: true,
                rtl: m.about.rtl,
            });
        }
    };

    const parseSymbol = (symbolId) => {
        const matches = symbolId.match(/^(.*)-([A-Za-z]+)(\d{2})$/i) || [];

        return matches[1] || symbolId;
    };

    topMoversPane && initTopMoversSlider();
}
